import React from "react";
import Text from "../components/shared/components/Text";
import { parseStringAmountWithUnitToNumber } from "./formaters";

export const DNI_REGEX = /^(\d{8})([A-Za-z])$/;
export const NIE_REGEX = /^[XYZxyz]\d{7,8}[A-Za-z]$/;
export const PASSPORT_REGEX = /^[A-Za-z0-9]{6,15}$/;
export const IBAN_REGEX =
  /([a-zA-Z]{2})\s*\t*(\d{2})\s*\t*(\d{4})\s*\t*(\d{4})\s*\t*(\d{2})\s*\t*(\d{10})/g;
export const CUPS_REGEX = /^ES.{18,20}$/;

export const spainIdType = (str) => {
  if (str) {
    if (str.match(DNI_REGEX)) {
      return "dni";
    }
    if (str.match(NIE_REGEX)) {
      return "nie";
    }
  }
  return false;
};

const validDNI = (dni) => {
  const dniLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
  const letter = dniLetters.charAt(parseInt(dni, 10) % 23);

  return letter === dni.charAt(8);
};

const validNIE = (nie) => {
  let niePrefix = nie.charAt(0);

  switch (niePrefix) {
    case "X":
      niePrefix = 0;
      break;
    case "Y":
      niePrefix = 1;
      break;
    case "Z":
      niePrefix = 2;
      break;
    default:
  }

  return validDNI(niePrefix + nie.substr(1));
};

export const validateDNIorNIE = (document) => {
  let valid = false;
  if (document) {
    const documentUp = document.toUpperCase().replace(/\s/, "");
    const type = spainIdType(documentUp);
    switch (type) {
      case "dni":
        valid = validDNI(documentUp);
        break;
      case "nie":
        valid = validNIE(documentUp);
        break;
      default:
    }
  }
  return valid;
};

export const validatePhoneWithPrefix = (num) => {
  if (!num) {
    return false;
  }
  let validatedNum = num;
  if (
    validatedNum.substring(0, 2) === "00" ||
    validatedNum.substring(0, 1) === "+" ||
    validatedNum.length === 9
  ) {
    if (validatedNum.substring(0, 2) === "00") {
      validatedNum = "+".concat(num.substring(2));
    }
    if (validatedNum.length === 9) {
      validatedNum = "+34".concat(num);
    }
    if (validatedNum.length < 9) {
      return false;
    }
  } else return false;
  return validatedNum;
};

export const validateMinimumRentValueAndReturnMessage = (value) => {
  const minimumRent = 1;
  const rentInt = parseStringAmountWithUnitToNumber(value);
  if (rentInt < minimumRent) {
    return (
      <Text
        tId={"RENT_AMOUNT_GREATER_THAN_VALUE"}
        dynamicDataTexts={[minimumRent]}
      />
    );
  }
};

export const validateKeyboardInputDate = ({
  value,
  disablePast,
  disableFuture,
  minDate,
  maxDate,
}) => {
  const time = value.getTime();
  const currentMoment = new Date().getTime();

  if (isNaN(time)) {
    return <Text tId={"INVALID_DATE"} />;
  }
  if (disablePast && currentMoment > time) {
    return <Text tId={"PAST_DATE_NOT_ALLOWED"} />;
  }
  if (disableFuture && currentMoment < time) {
    return <Text tId={"FUTURE_DATE_NOT_ALLOWED"} />;
  }
  if (minDate && minDate > time) {
    return <Text tId={"INVALID_DATE"} />;
  }
  if (maxDate && maxDate < time) {
    return <Text tId={"INVALID_DATE"} />;
  }
};
